import Hashids from "hashids";

var hashids = new Hashids("720 yun random Id", 16, "abcdefghijklmnopqrstuvwxyz0123456789");

var num = 0;

export default function randomId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "r_";

  var code = hashids.encode(Date.now(), num++);
  return "" + prefix + code;
}